import { QuotationPersonalInformation } from './QuotationPersonalInformation';

export interface QuotationRequestViewModel {
  personalInformation: QuotationPersonalInformation;
  description?: string;
}
